module.exports = __webpack_public_path__ + "img/codetest_nodata.d6c4a828.svg";